import { c as _c } from "react/compiler-runtime";
import { TourCard } from "@website/accommodation-ui/tour-card";
import { Skeleton } from "@website/ui/skeleton";
import { BannerSlide } from "@website/widget/banner-slide";
const TourResults = properties => {
  const $ = _c(21);
  const {
    solutions,
    isLoading,
    webengageData,
    installmentWallet,
    midPageBanner,
    noFollow
  } = properties;
  let t0;
  if ($[0] !== installmentWallet || $[1] !== noFollow || $[2] !== solutions || $[3] !== webengageData) {
    t0 = solutions?.slice(0, 1)?.map((solution, index) => <TourCard key={solution.searchId} {...solution} installmentWallet={installmentWallet} noFollow={noFollow} tourIndex={++index} webengageData={webengageData} />);
    $[0] = installmentWallet;
    $[1] = noFollow;
    $[2] = solutions;
    $[3] = webengageData;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== midPageBanner || $[6] !== noFollow || $[7] !== solutions?.length) {
    t1 = midPageBanner?.length > 0 && solutions?.length > 1 && <div className="w-full"><BannerSlide className="p-0" list={midPageBanner} noFollow={noFollow} /></div>;
    $[5] = midPageBanner;
    $[6] = noFollow;
    $[7] = solutions?.length;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== installmentWallet || $[10] !== noFollow || $[11] !== solutions || $[12] !== webengageData) {
    t2 = solutions?.slice(1)?.map((solution_0, index_0) => <TourCard key={solution_0.searchId} {...solution_0} installmentWallet={installmentWallet} noFollow={noFollow} tourIndex={++index_0 + 1} webengageData={webengageData} />);
    $[9] = installmentWallet;
    $[10] = noFollow;
    $[11] = solutions;
    $[12] = webengageData;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== isLoading) {
    t3 = isLoading && Array.from({
      length: 3
    }).map(_temp);
    $[14] = isLoading;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t0 || $[17] !== t1 || $[18] !== t2 || $[19] !== t3) {
    t4 = <>{t0}{t1}{t2}{t3}</>;
    $[16] = t0;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
};
export default TourResults;
function _temp(_, index_1) {
  return <div className="flex h-60 w-full justify-between overflow-hidden rounded-xl bg-white" key={`TourResults-${++index_1}`}><div className="w-80"><Skeleton height={240} /></div><div className="m-4 flex flex-1 flex-col gap-4"><div className="w-64 overflow-hidden rounded"><Skeleton height={16} /></div><div className="w-36 overflow-hidden rounded"><Skeleton height={16} /></div><div className="w-56 overflow-hidden rounded"><Skeleton height={16} /></div><div className="w-16 overflow-hidden rounded"><Skeleton height={16} /></div></div><div className="border-r-outline-thin flex flex-col items-center justify-end gap-2 border-r p-4"><div className="w-16 overflow-hidden rounded"><Skeleton height={12} /></div><div className="w-36 overflow-hidden rounded"><Skeleton height={16} /></div><div className="my-4 w-24 overflow-hidden rounded"><Skeleton height={24} /></div><div className="w-36 overflow-hidden rounded"><Skeleton height={36} /></div></div></div>;
}